// The cohort clock. One source of truth for "what week is it".
// Calendar: 2 matriculation weeks (instructional week 0), then 24 instructional
// weeks with a consolidation week after weeks 12 and 20. 28 calendar weeks total.
export function instructionalWeek(startDateStr, now = new Date()) {
  if (!startDateStr) return { week: 0, label: "Matriculation", consolidation: false };
  const start = new Date(startDateStr + "T00:00:00");
  const cal = Math.floor((now - start) / (7 * 24 * 3600 * 1000));
  if (cal < 0) return { week: 0, label: "Pre-term", consolidation: false, notStarted: true };
  if (cal <= 1) return { week: 0, label: "Matriculation", consolidation: false };
  if (cal <= 13) return { week: cal - 1, label: `Week ${cal - 1}`, consolidation: false };
  if (cal === 14) return { week: 12, label: "Consolidation week", consolidation: true };
  if (cal <= 22) return { week: cal - 2, label: `Week ${cal - 2}`, consolidation: false };
  if (cal === 23) return { week: 20, label: "Consolidation week", consolidation: true };
  if (cal <= 27) return { week: cal - 3, label: `Week ${cal - 3}`, consolidation: false };
  return { week: 24, label: "Post-programme", consolidation: false, finished: true };
}
